import {
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormLabel,
    Grid,
    MenuItem,
    Slider,
    TextField,
    Tooltip,
    Typography,
} from "@material-ui/core";
import { inputColor, inputVariant } from "../../settings/inputConfig";

import CloseIcon from "@material-ui/icons/Close";
import ContinuarSinPorcentajeSectorEnfocado from "./ContinuarSinPorcentajeSectorEnfocado";
import { Fragment } from "react";
import InfoIcon from "@material-ui/icons/Info";
import PrincipalProveedorForm from "./PrincipalProveedorForm";
import ProveedoresTitle from "../layout/ProveedoresTitle";
import { enumMaxWidth } from "../../settings/enumConfig";
import { useInformacionComplementaria } from "../../context/InformacionComplementariaContext";

const InformacionComplementaria = () => {
    const {
        listaTipoMonedas,
        listaCertificaciones,
        listaDiasPago,
        listaRangoPrecio,
        listaSectorProveedor,
        principalProveedorForm1,
        principalProveedorForm2,
        principalProveedorForm3,
        principalClienteForm1,
        principalClienteForm2,
        principalClienteForm3,
        informacionComplementariaForm,
        otrosCertificados,
        otrosSectores,
        Extranjero,
        errorSectores,
        handleChangePrincipalProveedor1,
        handleChangePrincipalProveedor2,
        handleChangePrincipalProveedor3,
        handleChangePrincipalCliente1,
        handleChangePrincipalCliente2,
        handleChangePrincipalCliente3,
        handleChangeInfCompText,
        handleChangeInfCompUInt,
        handleChangeInfCompNoError,
        handleClickSeleccionarCertificado,
        handleClickSeleccionarSector,
        handleClickOtrosCertificados,
        handleClickOtrosSectores,
        handleChangeSlidePrivado,
        handleChangeSlideGobierno,
        handleClickRegresar,
        handleClickSiguiente,
        handleClickDeleteChipMoneda,
    } = useInformacionComplementaria();

    const {
        txtCondicionPago,
        txtMonedaFacturacion,
        txtNumeroTotalClientes,
        txtOtrosCertificados,
        txtPorcentajeParticipacionSectorGobierno,
        txtPorcentajeParticipacionSectorPrivado,
        txtRangoIngresosAnuales,
        txtOtrosSectoresProveedor,
    } = informacionComplementariaForm;

    return (
        <Fragment>
            <Grid container spacing={4} className="content-over">
                <Grid item xs={12}>
                    <Box style={{ borderRadius: "15px", maxWidth: enumMaxWidth, margin: "auto" }}>
                        <Grid container spacing={4}>
                            {listaTipoMonedas.length === 0 || listaCertificaciones.length === 0 || listaDiasPago.length === 0 || listaRangoPrecio.length === 0 || listaSectorProveedor.length === 0 ? (
                                <Grid item xs={12} className="center">
                                    <CircularProgress />
                                    <Typography>Cargando formulario...</Typography>
                                </Grid>
                            ) : (
                                <Fragment>
                                    <Grid item xs={12} hidden="hidden" >
                                        <ProveedoresTitle>Principales proveedores</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12} hidden="hidden">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle2">
                                                    Ingrese sus tres principales proveedores, para cada proveedor proporcione razón social y
                                                    el tipo de servicio que les suministra
                                                </Typography>
                                            </Grid>
                                            <PrincipalProveedorForm
                                                title="Proveedor principal 1:"
                                                form={principalProveedorForm1}
                                                handleChange={handleChangePrincipalProveedor1}
                                            />
                                            <PrincipalProveedorForm
                                                title="Proveedor principal 2:"
                                                form={principalProveedorForm2}
                                                handleChange={handleChangePrincipalProveedor2}
                                            />
                                            <PrincipalProveedorForm
                                                title="Proveedor principal 3:"
                                                form={principalProveedorForm3}
                                                handleChange={handleChangePrincipalProveedor3}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>Clientes de referencia</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle2">
                                                    Ingrese sus tres principales clientes, para cada cliente proporcione razón social y el
                                                    tipo de servicio que le suministran
                                                </Typography>
                                            </Grid>
                                            <PrincipalProveedorForm
                                                title="Cliente de referencia 1:"
                                                form={principalClienteForm1}
                                                handleChange={handleChangePrincipalCliente1}
                                                required
                                            />
                                            <PrincipalProveedorForm
                                                title="Cliente de referencia 2:"
                                                form={principalClienteForm2}
                                                handleChange={handleChangePrincipalCliente2}
                                                required
                                            />
                                            <PrincipalProveedorForm
                                                title="Cliente de referencia 3:"
                                                form={principalClienteForm3}
                                                handleChange={handleChangePrincipalCliente3}
                                                required
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>Certificaciones</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl>
                                            <FormGroup>
                                                {listaCertificaciones.map((x) => (
                                                    <FormControlLabel
                                                        key={x.iIdCertificacion}
                                                        label={x.sDescripcionCertificado}
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={x.bCheck}
                                                                name={x.sDescripcionCertificado}
                                                                onChange={handleClickSeleccionarCertificado(x.iIdCertificacion)}
                                                            />
                                                        }
                                                    />
                                                ))}
                                                <FormControlLabel
                                                    label="Otros"
                                                    control={
                                                        <Checkbox
                                                            color="primary"
                                                            checked={otrosCertificados}
                                                            onChange={handleClickOtrosCertificados}
                                                        />
                                                    }
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                    {otrosCertificados && (
                                        <Grid item xs={12}>
                                            <TextField
                                                name={txtOtrosCertificados.name}
                                                label={txtOtrosCertificados.label}
                                                required={txtOtrosCertificados.required}
                                                value={txtOtrosCertificados.value}
                                                error={txtOtrosCertificados.error}
                                                helperText={txtOtrosCertificados.error && txtOtrosCertificados.helper}
                                                placeholder={txtOtrosCertificados.placeholder}
                                                onChange={handleChangeInfCompNoError}
                                                variant={inputVariant}
                                                color={inputColor}
                                                fullWidth
                                                multiline
                                                inputProps={{
                                                    maxLength: 100,
                                                }}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>Información adicional</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            name={txtMonedaFacturacion.name}
                                            label={txtMonedaFacturacion.label}
                                            required={txtMonedaFacturacion.required}
                                            value={txtMonedaFacturacion.value}
                                            error={txtMonedaFacturacion.required && txtMonedaFacturacion.error}
                                            helperText={
                                                txtMonedaFacturacion.required && txtMonedaFacturacion.error && txtMonedaFacturacion.helper
                                            }
                                            onChange={handleChangeInfCompText}
                                            variant={inputVariant}
                                            color={inputColor}
                                            fullWidth
                                            select
                                            multiline
                                            SelectProps={{
                                                multiple: true,
                                                renderValue: (selected) => (
                                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                                        {selected.map((value) => (
                                                            <Chip
                                                                key={value.iIdMonedas}
                                                                label={value.sCodigo}
                                                                style={{ marginRight: 10 }}
                                                                color="primary"
                                                                onDelete={() => handleClickDeleteChipMoneda(value)}
                                                                deleteIcon={<CloseIcon />}
                                                                onMouseDown={(event) => {
                                                                    event.stopPropagation();
                                                                }}
                                                            />
                                                        ))}
                                                    </div>
                                                ),
                                                MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    getContentAnchorEl: null,
                                                },
                                            }}
                                        >
                                            {listaTipoMonedas.map((x) => (
                                                <MenuItem key={x.iIdMonedas} value={x}>
                                                    {x.sCodigo}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            name={txtCondicionPago.name}
                                            label={txtCondicionPago.label}
                                            required={txtCondicionPago.required}
                                            value={txtCondicionPago.value}
                                            error={txtCondicionPago.required && txtCondicionPago.error}
                                            helperText={txtCondicionPago.required && txtCondicionPago.error && txtCondicionPago.helper}
                                            onChange={handleChangeInfCompText}
                                            variant={inputVariant}
                                            color={inputColor}
                                            fullWidth
                                            select
                                            SelectProps={{
                                                MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    getContentAnchorEl: null,
                                                },
                                            }}
                                        >
                                            <MenuItem value="">-- Seleccione la condición de pago</MenuItem>
                                            {listaDiasPago.map((x) => (
                                                <MenuItem key={x.iIdDias} value={x.iIdDias.toString()}>
                                                    {x.sDias}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            name={txtNumeroTotalClientes.name}
                                            label={txtNumeroTotalClientes.label}
                                            required={txtNumeroTotalClientes.required}
                                            value={txtNumeroTotalClientes.value}
                                            error={txtNumeroTotalClientes.required && txtNumeroTotalClientes.error}
                                            helperText={
                                                txtNumeroTotalClientes.required &&
                                                txtNumeroTotalClientes.error &&
                                                txtNumeroTotalClientes.helper
                                            }
                                            onChange={handleChangeInfCompUInt}
                                            variant={inputVariant}
                                            color={inputColor}
                                            fullWidth
                                            inputProps={{
                                                maxLength: 10,
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <Tooltip
                                                title="Del total de cliente, cuál es el porcentaje que pertenece al sector privado"
                                                placement="top"
                                                arrow
                                            >
                                                <InfoIcon color="secondary" />
                                            </Tooltip>
                                            <Typography>
                                                &nbsp;Porcentaje de participación del sector privado:{" "}
                                                {txtPorcentajeParticipacionSectorPrivado.value}%
                                            </Typography>
                                        </div>
                                        <Slider
                                            value={txtPorcentajeParticipacionSectorPrivado.value}
                                            min={0}
                                            max={100}
                                            step={1}
                                            onChange={handleChangeSlidePrivado}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <Tooltip
                                                title="Del total de cliente, cuál es el porcentaje que pertenece al sector gobierno"
                                                placement="top"
                                                arrow
                                            >
                                                <InfoIcon color="secondary" />
                                            </Tooltip>
                                            <Typography style={{ flex: 1 }}>
                                                &nbsp;Porcentaje de participación del sector gobierno:{" "}
                                                {txtPorcentajeParticipacionSectorGobierno.value}%
                                            </Typography>
                                        </div>
                                        <Slider
                                            value={txtPorcentajeParticipacionSectorGobierno.value}
                                            min={0}
                                            max={100}
                                            step={1}
                                            onChange={handleChangeSlideGobierno}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            name={txtRangoIngresosAnuales.name}
                                            label={txtRangoIngresosAnuales.label}
                                            required={txtRangoIngresosAnuales.required}
                                            value={txtRangoIngresosAnuales.value}
                                            error={txtRangoIngresosAnuales.required && txtRangoIngresosAnuales.error}
                                            helperText={
                                                txtRangoIngresosAnuales.required &&
                                                txtRangoIngresosAnuales.error &&
                                                txtRangoIngresosAnuales.helper
                                            }
                                            onChange={handleChangeInfCompText}
                                            variant={inputVariant}
                                            color={inputColor}
                                            fullWidth
                                            select
                                            SelectProps={{
                                                MenuProps: {
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    getContentAnchorEl: null,
                                                },
                                            }}
                                        >
                                            <MenuItem value="">-- Seleccione un rango de ingresos anuales</MenuItem>
                                            {listaRangoPrecio.map((x) => (
                                                <MenuItem key={x.iRangoPrecio} value={x.iRangoPrecio.toString()}>
                                                    {Extranjero ? x.sDescripcionRangoPrecioExtranjero : x.sDescripcionRangoPrecio}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <ProveedoresTitle>Sectores al que pertenece</ProveedoresTitle>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl>
                                            {errorSectores && (
                                                <FormLabel error={errorSectores}> Seleccione al menos un sector para continuar</FormLabel>
                                            )}

                                            <FormGroup>
                                                {listaSectorProveedor.map((x) => (
                                                    <FormControlLabel
                                                        key={x.iSectorProveedor}
                                                        label={x.sDescripcionSectorProveedor}
                                                        control={
                                                            <Checkbox
                                                                color="primary"
                                                                checked={x.bCheck}
                                                                name={x.sDescripcionSectorProveedor}
                                                                onChange={handleClickSeleccionarSector(x.iSectorProveedor)}
                                                            />
                                                        }
                                                    />
                                                ))}
                                                <FormControlLabel
                                                    label="Otros"
                                                    control={
                                                        <Checkbox
                                                            color="primary"
                                                            checked={otrosSectores}
                                                            onChange={handleClickOtrosSectores}
                                                        />
                                                    }
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                    {otrosSectores && (
                                        <Grid item xs={12}>
                                            <TextField
                                                name={txtOtrosSectoresProveedor.name}
                                                label={txtOtrosSectoresProveedor.label}
                                                required={txtOtrosSectoresProveedor.required}
                                                value={txtOtrosSectoresProveedor.value}
                                                error={txtOtrosSectoresProveedor.error}
                                                helperText={txtOtrosSectoresProveedor.error && txtOtrosSectoresProveedor.helper}
                                                placeholder={txtOtrosSectoresProveedor.placeholder}
                                                onChange={handleChangeInfCompNoError}
                                                variant={inputVariant}
                                                color={inputColor}
                                                fullWidth
                                                multiline
                                                inputProps={{
                                                    maxLength: 100,
                                                }}
                                            />
                                        </Grid>
                                    )}
                                </Fragment>
                            )}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <div className="form-buttons">
                        <Button variant="contained" color="secondary" onClick={handleClickRegresar}>
                            Regresar
                        </Button>
                        <Button variant="contained" color="primary" style={{ marginLeft: 10 }} onClick={handleClickSiguiente}>
                            Siguiente
                        </Button>
                    </div>
                </Grid>
            </Grid>
            <ContinuarSinPorcentajeSectorEnfocado />
        </Fragment>
    );
};

export default InformacionComplementaria;
